import { TranslatorForm } from "../../@components/AiToolkit/Translation/TranslationForm";

export function Translator() {
  return <TranslatorForm />;
}
